import { Button, styled, useTheme } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useOrganization } from 'src/contexts/OrganizationContext';

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.contrast,
  backgroundColor: theme.palette.surface.sidebarDarker,
  borderRadius: '4px',
  justifyContent: 'flex-start',
  padding: '4px 16px 4px 12px',
  fontSize: '14px',
  width: '100%',
  ':hover': {
    backgroundColor: theme.palette.primary.light,
  },
}));

interface Props {
  title: string;
  href: string;
}

export const NavbarAdminSubButton = ({ title, href }: Props) => {
  const router = useRouter();
  const theme = useTheme();
  const { organization, isLoading } = useOrganization();

  // ローディング中またはorganizationがない場合は何も表示しない
  if (isLoading || !organization) {
    return null;
  }

  // 遷移先URLと現在のパスが一致しているかどうか
  const isTarget = router.pathname === href;
  const buttonStyles = isTarget
    ? {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.text.contrast,
      }
    : {};
  return (
    <Link href={{ pathname: href, query: { organizationName: organization.name } }}>
      <StyledButton sx={buttonStyles}>{title}</StyledButton>
    </Link>
  );
};
